/* ============================================================
   Furyx — one address, two homes.

   Every sign-up on this site posts to Shopify first: that is what
   creates the customer record carrying the `the-order` tag, which is
   what The Register and the numbering run on. But the Shopify ->
   Klaviyo integration drops those profiles into Klaviyo's DEFAULT
   list, not into The Order — so without this file The Order stays
   empty forever while the audience piles up somewhere else.

   So we also post the address straight to Klaviyo's public client
   subscription endpoint, into The Order by list id.

   Two details this depends on:
     - the listener is on the CAPTURE phase, so it runs before the
       popup's own submit handler calls preventDefault();
     - the request uses keepalive, so it survives the page navigation
       on the forms that still submit the classic way (footer, the
       homepage block, the waitlist page).

   Config lives in snippets/fx-head.liquid.
   ============================================================ */
(function () {
  var cfg = window.fxKlaviyo || {};
  if (!cfg.company || !cfg.list) return;

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company);
  var REVISION = cfg.revision || '2024-10-15';
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;

  function subscribe(email, source) {
    if (!email || !window.fetch) return Promise.resolve(false);
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source || 'Furyx site',
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: cfg.list } } }
      }
    };
    return fetch(ENDPOINT, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.status === 202 || r.ok; })
      .catch(function () { return false; });
  }

  /* exposed so a section can call it directly if it ever needs to */
  window.fxKlaviyoSubscribe = subscribe;

  function isNewsletterForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    var t = form.querySelector('input[name="form_type"]');
    return !!t && t.value === 'customer';
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!isNewsletterForm(form)) return;

      var input = form.querySelector('input[name="contact[email]"], input[type="email"]');
      if (!input) return;

      var val = (input.value || '').trim().toLowerCase();
      if (!EMAIL_RE.test(val)) return;

      /* a resubmit of the same address should not fire twice */
      if (form.getAttribute('data-fx-kl-sent') === val) return;
      form.setAttribute('data-fx-kl-sent', val);

      subscribe(val, 'Furyx — ' + (form.getAttribute('id') || 'form') + ' — ' + location.pathname);
    },
    true
  );
})();